import React, { useMemo } from "react";
import { useAIAssistant } from "@jugl-web/domain-resources/ai-assistant/providers";
import { AIAssistantPromptSuggestion } from "@jugl-web/domain-resources/ai-assistant/AIAssistantPromptSuggestion";
import { useTranslations } from "@jugl-web/utils";
import { AIPromptSuggestions } from "@jugl-web/domain-resources/ai-assistant/consts";
import { useTaskObjectNaming } from "@jugl-web/domain-resources/tasks/hooks/useTaskObjectNaming";
import arivuImage from "../../assets/arivu.png";

export const AIChatEmptyState: React.FC = () => {
  const { t } = useTranslations();
  const { user, agent, sendMessage, entityId } = useAIAssistant();

  const taskObjectNaming = useTaskObjectNaming({
    entityId,
    boardId: agent?.agent === "board" ? agent?.board_id : null,
  });

  const suggestions = useMemo(() => {
    if (!agent) return [];
    if (agent?.agent === "board") {
      return AIPromptSuggestions[agent.agent].map((suggestion) =>
        suggestion.replace("tasks", taskObjectNaming.plural)
      );
    }
    return AIPromptSuggestions[agent.agent];
  }, [agent, taskObjectNaming.plural]);

  return (
    <div className="mx-auto flex h-full max-w-[1200px] flex-col items-center px-6 pt-20 text-center">
      <img
        src={arivuImage as unknown as string}
        alt=""
        className="border-grey-200 h-[100px] w-[100px] rounded-full border-2 border-solid"
      />
      <span className="text-dark font-secondary mt-4 text-2xl font-medium">
        {t(
          {
            id: "ai-assistant-dialog-component.hello-name",
            defaultMessage: "Hello {name}!",
          },
          { name: user?.displayName || "" }
        )}
      </span>
      <span className="text-dark-800 font-secondary mt-1 text-[15px]">
        {t(
          {
            id: "ai-assistant-dialog-component.arivu-description",
            defaultMessage:
              "Im {arivu}, your personal AI Assistant 👋{br} Glad to help you anytime you have some questions",
          },
          {
            br: <br />,
            arivu: (
              <span className="bg-[linear-gradient(237deg,_#F33A9E_1.05%,_#2196F3_75.01%)] bg-clip-text text-[17px] font-semibold italic text-transparent">
                Arivu
              </span>
            ),
          }
        )}
      </span>
      {agent && (
        <div className="mt-20 flex w-full flex-col gap-4">
          {suggestions.map((prompt, idx) => (
            <AIAssistantPromptSuggestion
              key={+idx}
              onClick={() => sendMessage(prompt)}
              prompt={prompt}
            />
          ))}
        </div>
      )}
    </div>
  );
};
